module.exports = __webpack_public_path__ + "img/face-pensive.61da4c14.svg";